import { OperationValidationRequest, OperationValidationResponse } from './../models/control-panel.model';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ControlPanelStore } from '../control-panel-service/control-panel.store';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import jsPDF from 'jspdf';
import autoTable, { Table } from 'jspdf-autotable';
import { ExcelService } from '@app/@shared/services/print/excel.service';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { dataPrint } from '@app/requests/model/requests-model';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { Credentials } from '@app/@core/models/login-models';
import {
  BUSINESS_DIRECTOR,
  CHAIN,
  MACRO_CHAIN,
  MACRO_OFFICE,
  OFFICE_DIRECTOR,
} from '@app/@core/constants/users.constants';
import { TranslateService } from '@ngx-translate/core';
import { DatepickerUtilsService } from '@app/@shared/services/utils/datepicker-utils.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LOCALE_ES } from '@app/@core/constants/common.constants';
import FileSaver from 'file-saver';

const moment = _moment;
const FORM_PARAM_MACRO_CHAIN = 'macroChain';
const FORM_PARAM_MACRO_OFFICE = 'macroOffice';

const emptyCommonDataDTO: CommonDataDTO = {
  id: undefined,
  value: '',
};

@UntilDestroy()
@Component({
  selector: 'app-operation-validation',
  templateUrl: './operation-validation.component.html',
  styleUrls: ['./operation-validation.component.scss'],
})
export class OperationValidationComponent implements OnInit {
  maxDate: Date = new Date();
  maxFinalDate: Date;
  minDate: Date;

  disabledSearchButton: boolean = true;
  excelAndPdfDisabled: boolean = true;
  noData: boolean = false;

  officeList: CommonDataDTO[] = [];
  externalCommercialList: CommonDataDTO[] = [];
  establishmentList: CommonDataDTO[] = [];
  docSituationList: CommonDataDTO[] = [];
  listForQuery: string[] = [];
  macroChainList: CommonDataDTO[] = [];
  macroOfficeList: CommonDataDTO[] = [];

  operationsByStatus: OperationValidationResponse;

  isMacroChainUser: boolean = false;
  isMacroOfficeUser: boolean = false;
  isBusinessDirector: boolean = false;

  private userInfo: Credentials;

  allData: any[] = [];
  operationValidationForm: FormGroup;

  displayedColumns: string[] = [
    'agent',
    'numContract',
    'documentHolder',
    'document',
    'documentSituation',
    'incidenceDate',
    'formalizedDate',
    'expirationDate',
  ];
  public head = [
    'operationValidation.agent',
    'operationValidation.numContract',
    'operationValidation.documentHolder',
    'operationValidation.document',
    'operationValidation.documentSituation',
    'operationValidation.incidenceDate',
    'operationValidation.formalizedDate',
    'operationValidation.expirationDate',
  ];

  typeList: any[] = [
    { name: 'PA', title: 'request.status.approve' },
    { name: '00', title: 'request.status.pending' },
    { name: 'PE', title: 'request.status.study' },
    { name: 'DN', title: 'request.status.denied' },
    { name: '90', title: 'request.status.formalise' },
    { name: '95', title: 'request.status.cancel' },
    { name: 'PV', title: 'PENDIENTES DE VALIDACION' },
    { name: '15', title: 'request.status.pending.bug' },
    { name: 'PF', title: 'request.status.signed' },
    { name: '35', title: 'request.status.conditioned.pending' },
  ];

  searchParams: any;

  // dataSource = new MatTableDataSource<any>();

  constructor(
    private formBuilder: FormBuilder,
    private controlPanelStore: ControlPanelStore,
    private excelService: ExcelService,
    private customValidators: CustomValidatorsService,
    private combosStore: CombosStore,
    private translateService: TranslateService,
    private datepickerUtils: DatepickerUtilsService
  ) {
    let dataString: string = localStorage.getItem('credentials');
    this.userInfo = JSON.parse(dataString);

    this.translateService.onLangChange.subscribe(() => {
      if (this.allData.length > 0) {
        this.updateSearchParams();
      }
    });
  }

  ngOnInit(): void {
    this.operationValidationForm = this.formBuilder.group(
      {
        initialDate: ['', [Validators.required, this.customValidators.checkIsFutureDate]],
        finalDate: [{ value: '', disabled: true }, [Validators.required, this.customValidators.checkIsFutureDate]],
        office: [''],
        externalCommercial: [''],
        documentSituation: [''],
        queryTypes: this.formBuilder.group({}),
        // establishment: [''],
        // sitDocument: [''],
        // typeSearch: [''],
        // nifNie: [''],
        // numContract: [''],
      },
      {
        validators: [
          this.customValidators.isDateValid('initialDate', 'finalDate', 'dateInvalid'),
          this.customValidators.isMoreThanAYearApart('initialDate', 'finalDate', 'dateYearError'),
        ],
      }
    );

    const formArray = <FormGroup>this.operationValidationForm.get('queryTypes');

    this.typeList.forEach((x) => {
      formArray.addControl(x.name, new FormControl(false));
    });

    this.translateService.currentLang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan();
    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((event) =>
        event.lang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan()
      );

    this.operationValidationForm.controls.initialDate.statusChanges.subscribe((value) => {
      const initialDateValue = this.operationValidationForm.controls.initialDate.value;
      if (value === 'VALID' || initialDateValue) {
        this.minDate = initialDateValue.toDate();
        this.maxFinalDate = moment(initialDateValue).add(11, 'months').endOf('month').toDate();
        if (this.operationValidationForm.controls.finalDate.disabled)
          this.operationValidationForm.controls.finalDate.enable();
      } else {
        this.minDate = undefined;
        this.maxFinalDate = this.maxDate;
      }
    });

    this.operationValidationForm.statusChanges.subscribe(() => {
      let isValid = false;
      this.typeList.forEach((element) => {
        if (this.operationValidationForm.controls.queryTypes.value[element.name]) {
          isValid = true;
        }
      });

      if (
        isValid &&
        this.operationValidationForm.controls.initialDate.valid &&
        this.operationValidationForm.controls.finalDate.valid
      ) {
        this.disabledSearchButton = false;
      } else {
        this.disabledSearchButton = true;
      }
    });

    this.operationValidationForm.controls.office.valueChanges.subscribe((value) => {
      this.onOfficeSelected();
    });

    this.validateMacroChainUser();
    if (this.isBusinessDirector) this.initMacroUsers([FORM_PARAM_MACRO_CHAIN, FORM_PARAM_MACRO_OFFICE]);
    else if (this.isMacroChainUser) this.initMacroUsers([FORM_PARAM_MACRO_CHAIN]);
    else if (this.isMacroOfficeUser) this.initMacroUsers([FORM_PARAM_MACRO_OFFICE]);
    else {
      this.loadOffices();
      this.loadExternalCommercials();
      this.loadDocumentSituation();
    }
  }

  updateSearchParams() {
    this.searchParams = [
      `De ${this.operationValidationForm.controls.initialDate.value
        .startOf('month')
        .format('MM-YYYY')} a ${this.operationValidationForm.controls.finalDate.value
        .endOf('month')
        .format('MM-YYYY')}`,

      this.operationValidationForm.controls.office.value
        ? this.officeList.find((office) => office.id === this.operationValidationForm.controls.office.value)?.value
        : this.translateService.instant('excel.allIdsFem'),

      this.operationValidationForm.controls.externalCommercial.value
        ? this.externalCommercialList.find(
            (externalCommercial) =>
              externalCommercial.id === this.operationValidationForm.controls.externalCommercial.value
          )?.value
        : this.translateService.instant('excel.allIds'),
      this.operationValidationForm.controls.documentSituation.value
        ? this.docSituationList.find(
            (documentSituation) =>
              documentSituation.id === this.operationValidationForm.controls.documentSituation.value
          )?.value
        : this.translateService.instant('excel.allIds'),
    ];
  }

  consult() {
    if (this.operationValidationForm.value.queryTypes) {
      this.listForQuery = [];
      this.typeList.forEach((element) => {
        if (this.operationValidationForm.controls.queryTypes.value[element.name]) {
          this.listForQuery.push(element.name);
        }
      });
    }

    const request: OperationValidationRequest = {
      fromDate: this.operationValidationForm.controls.initialDate.value.startOf('month').format('YYYY-MM-DD'),
      toDate: this.operationValidationForm.controls.finalDate.value.endOf('month').format('YYYY-MM-DD'),
      officeId: this.operationValidationForm.controls.office.value,
      externalCommercialUserId: this.operationValidationForm.controls.externalCommercial.value,
      documentStatus: this.operationValidationForm.controls.documentSituation.value,
      statusRequestCodes: this.listForQuery,
    };

    this.updateSearchParams();

    this.allData = [];
    this.controlPanelStore.getOperationsValidation(request).then(
      (data) => {
        if (data) {
          if (data.elements.length === 0) {
            this.noData = true;
            this.operationsByStatus = null;
            this.excelAndPdfDisabled = true;
            this.allData = [];
          } else {
            this.noData = false;
            this.operationsByStatus = data;
            this.excelAndPdfDisabled = false;
            this.operationsByStatus.elements.forEach((item) => {
              item.items.forEach((OVItem) => {
                OVItem.formalizationDate = OVItem.formalizationDate
                  ? new Date(OVItem.formalizationDate).toISOString().split('T')[0]
                  : '';
                OVItem.creationDate = OVItem.creationDate
                  ? new Date(OVItem.creationDate).toISOString().split('T')[0]
                  : '';
                OVItem.expirationDate = OVItem.expirationDate
                  ? new Date(OVItem.expirationDate).toISOString().split('T')[0]
                  : '';
              });
            });
            data.elements.forEach((element) => {
              this.allData.push(element);
            });
            this.excelAndPdfDisabled = false;
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  createAllExcel() {
    let dataExcelPrint: any[] = [];
    let allDataExcel: dataPrint[] = [];
    let print: any;
    allDataExcel = this.allData;
    const filename =
      this.translateService.instant('operationValidation.excel.title') + moment().locale('es').format('DDMMYYYY');

    this.allData.forEach((item, index) => {
      console.log(item);
      if (item.items) {
        print = item.items;
      }
      print.map((data: any) => {
        const dataExcelOrder = JSON.stringify(data, [
          'businessName',
          'numRequest',
          'holderDoc',
          'documentDesc',
          'documentStatus',
          'creationDate',
          'formalizationDate',
          'expirationDate',
        ]);
        const ObjectDataExcel = JSON.parse(dataExcelOrder);
        dataExcelPrint.push(ObjectDataExcel);
      });
      allDataExcel[index].data = dataExcelPrint;
      dataExcelPrint = [];
    });

    this.updateOfficeByLanguage();
    this.updateCommercialByLanguage();
    const excelAllData = {
      fileName: filename,
      headers: this.head.map((header) => this.translateService.instant(header)),
      data: allDataExcel,
      commercialExt: this.searchParams[2],
      oficina: this.searchParams[1],
    };
    this.excelService.exportExcelAll(excelAllData, this.translateService.instant('operationValidation.operationList'));
  }

  createAllPdf() {
    new Promise((reject) => {
      try {
        let doc = new jsPDF({
          orientation: 'portrait',
          format: [220.804, 296.926],
        });
        const dateMoment = moment().locale('es');
        const filename =
          this.translateService.instant('operationValidation.excel.title') + dateMoment.format('DDMMYYYY');
        doc.setProperties({
          title: filename,
        });

        /* BODY */
        this.operationsByStatus?.elements.forEach((operValidItem) => {
          //RECORRE LAS TABLAS
          let dataPdf: any[] = [];

          //table
          operValidItem.items.forEach((item) => {
            const { ...datae } = item;
            const dataPdfOrder = JSON.stringify(datae, [
              'businessName',
              'numRequest',
              'holderDoc',
              'documentDesc',
              'documentStatus',
              'creationDate',
              'formalizationDate',
              'expirationDate',
            ]);

            const ObjectDataPdf = JSON.parse(dataPdfOrder);
            dataPdf.push(ObjectDataPdf);
          });

          doc = this.createPdfTable(doc, dataPdf, operValidItem.statusDesc);
        });

        let blob = doc.output('blob');
        FileSaver.saveAs(blob, filename);
        window.open(URL.createObjectURL(blob));
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  }

  createPdfTable(doc: jsPDF, dataPdf: any, tableTitle?: string): jsPDF {
    const lastAutoTable: Table = (doc as any).lastAutoTable; //la tabla de la pagina anterior
    const maxTableYCoordinate: number = 260;
    const tableYCoordinateFirstPage: number = 71;
    const margin = 45;

    //First time
    doc.setFontSize(10);

    let heightLastRow: number = 0;

    let startYTable: number = tableYCoordinateFirstPage;
    if (lastAutoTable) {
      const { finalY } = lastAutoTable;
      const expectedFinalY = finalY + 20;
      startYTable = finalY && expectedFinalY < maxTableYCoordinate ? expectedFinalY : margin;

      if (startYTable === margin) {
        doc.addPage();
      }
    }

    if (!lastAutoTable) {
      //Only first page
      //Second row
      const secondRowYCoordinate: number = 45;
      const secondRowXCoordinate: number = 13;

      this.updateOfficeByLanguage();
      doc.text(
        this.translateService.instant('excel.office') + this.searchParams[1],
        secondRowXCoordinate,
        secondRowYCoordinate
      );

      doc.text(
        this.translateService.instant('excel.period') + this.searchParams[0],
        secondRowXCoordinate,
        secondRowYCoordinate + 5
      );

      this.updateCommercialByLanguage();
      doc.text(
        this.translateService.instant('excel.commercial') + this.searchParams[2],
        secondRowXCoordinate,
        secondRowYCoordinate + 10
      );

      this.updateDocumentSituationByLanguage();
      doc.text(
        this.translateService.instant('excel.documentSituation') + this.searchParams[3],
        secondRowXCoordinate,
        secondRowYCoordinate + 15
      );
    }

    doc.text(tableTitle, 14, startYTable - 2);

    autoTable(doc, {
      startY: startYTable,
      head: [this.head.map((header) => this.translateService.instant(header))],
      headStyles: { fillColor: '#969696' },
      pageBreak: 'auto',
      rowPageBreak: 'avoid',
      showHead: 'everyPage',
      margin: { top: margin },
      body: dataPdf.map(Object.values),
      styles: { fontSize: 8, cellWidth: 'auto', overflow: 'linebreak' },
      didDrawCell: (data) => {
        if (data.row.index === dataPdf.length - 1) {
          heightLastRow = data.row.height;
        }
      },
      didDrawPage: (data) => {
        const { finalY } = lastAutoTable;
        if (!lastAutoTable || (finalY < startYTable && data.pageCount !== 1) || startYTable === margin) {
          /* HEADER */
          //TITLE
          const headerXCoordinate: number = 80;
          const headerYCoordinate: number = 20;
          doc.setFontSize(24);
          doc.setTextColor('1E90FF');
          doc.text(this.translateService.instant('excel.dashboard.title'), headerXCoordinate, headerYCoordinate);

          //IMAGE
          let img = new Image();
          img.src = 'assets/img/logo.PNG';
          doc.addImage(img, 'png', 3, 10, 58, 20);

          //First row
          doc.setTextColor('#000000');
          doc.setFontSize(12);

          const firstRowYCoordinate: number = 35;
          const titleXCoordinate: number = 75;
          doc.text(this.translateService.instant('operationValidation.title'), titleXCoordinate, firstRowYCoordinate);
          doc.setFontSize(10);

          const thirdColumnXCoordinate: number = 150;
          doc.text(
            this.translateService.instant('excel.date') + moment().locale('es').format('DD-MM-YYYY HH:mm:ss'),
            thirdColumnXCoordinate,
            firstRowYCoordinate - 3
          );
          doc.text(
            this.translateService.instant('excel.pag') + doc.getNumberOfPages(),
            thirdColumnXCoordinate,
            firstRowYCoordinate + 3
          );
        }
      },
    });
    console.log(doc);

    return doc;
  }

  /* COMBO LOADERS */
  private loadOffices = async (filter?: any) => {
    this.combosStore
      .getOffices(filter)
      .then(
        (data) => {
          if (data) {
            this.officeList = data.length === 1 ? [...data] : [emptyCommonDataDTO, ...data];
            if (this.officeList.length === 1)
              this.operationValidationForm.controls.office.setValue(this.officeList[0].id);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  };

  loadExternalCommercials(filter?: any) {
    this.controlPanelStore.getExternalCommercialsByFilter(filter).then(
      (data) => {
        if (data) {
          this.externalCommercialList = data.length === 1 ? [...data] : [emptyCommonDataDTO, ...data];
          if (this.externalCommercialList.length === 1)
            this.operationValidationForm.controls.externalCommercial.setValue(this.externalCommercialList[0].id);
        }
      },
      (error) => console.error(error)
    );
  }

  loadDocumentSituation() {
    this.controlPanelStore.getDocumentStatus().then(
      (data) => {
        if (data) {
          this.docSituationList = data.length === 1 ? [...data] : [emptyCommonDataDTO, ...data];
          if (this.docSituationList.length === 1)
            this.operationValidationForm.controls.documentSituation.setValue(this.docSituationList[0].id);
        }
      },
      (error) => console.error(error)
    );
  }

  private loadMacroChains = async () => {
    this.resetCombosExceptMacro();
    this.operationValidationForm.controls[FORM_PARAM_MACRO_CHAIN].setValue('');
    this.macroChainList = [];
    const promise = this.isBusinessDirector
      ? this.combosStore.getChainsByDivision(this.userInfo.division?.toString())
      : this.combosStore.getChainsFromMacroUser(this.userInfo.userId);
    promise
      .then(
        (data) => {
          if (data) {
            this.macroChainList =
              this.isBusinessDirector && data.length > 0 ? [emptyCommonDataDTO, ...data] : [...data];
            if (this.macroChainList.length === 1)
              this.operationValidationForm.controls[FORM_PARAM_MACRO_CHAIN].setValue(this.macroChainList[0]?.id);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  };

  private loadMacroOffices = async () => {
    this.resetCombosExceptMacro();
    this.operationValidationForm.controls[FORM_PARAM_MACRO_OFFICE].setValue('');
    this.macroOfficeList = [];
    const promise = this.isBusinessDirector
      ? this.combosStore.getOfficesByDivision(this.userInfo.division?.toString())
      : this.combosStore.getOfficesFromMacroUser(this.userInfo.userId);
    promise
      .then(
        (data) => {
          if (data) {
            this.macroOfficeList =
              this.isBusinessDirector && data.length > 0 ? [emptyCommonDataDTO, ...data] : [...data];
            if (this.macroOfficeList.length === 1)
              this.operationValidationForm.controls[FORM_PARAM_MACRO_OFFICE].setValue(this.macroOfficeList[0]?.id);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  };

  /* HANDLERS */
  onOfficeSelected() {
    const request = { officeId: this.operationValidationForm.controls.office.value };
    this.controlPanelStore.getExternalCommercialsByFilter(request).then(
      (data) => {
        if (data) {
          //mostrar comerciales según oficina
          this.externalCommercialList = data.length === 1 ? [...data] : [emptyCommonDataDTO, ...data];
          if (
            this.externalCommercialList.length === 1 ||
            (this.externalCommercialList.length !== 0 && request.officeId === undefined)
          )
            this.operationValidationForm.controls.externalCommercial.setValue(this.externalCommercialList[0].id);
        }
      },
      (error) => console.error(error)
    );
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, input: any) {
    const inputForm = typeof input === 'string' ? input : input?.getAttribute('formControlName');
    const control: AbstractControl = this.operationValidationForm.controls[inputForm];
    const ctrlValue = this.operationValidationForm.controls[inputForm].value;
    if (control.pristine) control.markAsDirty();
    if (ctrlValue) {
      ctrlValue.month(normalizedMonth.month());
      control.setValue(ctrlValue);
    } else {
      control.setValue(
        moment('1/' + (normalizedMonth.month() + 1).toString() + '/' + normalizedMonth.year().toString(), 'DD-MM-YYYY')
      );
    }
    datepicker.close();
  }

  chosenYearHandler(normalizedYear: Moment, input: any) {
    const inputForm = typeof input === 'string' ? input : input?.getAttribute('formControlName');
    const control: AbstractControl = this.operationValidationForm.controls[inputForm];
    const ctrlValue = this.operationValidationForm.controls[inputForm].value;
    if (ctrlValue) {
      ctrlValue.year(normalizedYear.year());
      control.setValue(ctrlValue);
    } else {
      control.setValue(moment('1/1/' + normalizedYear.year().toString(), 'DD-MM-YYYY'));
    }
  }

  private buildRequest = () => {
    let request;
    if (this.isBusinessDirector) {
      request = this.operationValidationForm.controls[FORM_PARAM_MACRO_CHAIN].value
        ? { chainId: this.operationValidationForm.controls[FORM_PARAM_MACRO_CHAIN].value, userType: CHAIN }
        : { officeId: this.operationValidationForm.controls[FORM_PARAM_MACRO_OFFICE].value, userType: OFFICE_DIRECTOR };
    } else if (this.isMacroChainUser)
      request = { chainId: this.operationValidationForm.controls[FORM_PARAM_MACRO_CHAIN].value, userType: CHAIN };
    else if (this.isMacroOfficeUser)
      request = {
        officeId: this.operationValidationForm.controls[FORM_PARAM_MACRO_OFFICE].value,
        userType: OFFICE_DIRECTOR,
      };
    else request = {};
    return request;
  };

  private validateMacroChainUser = () => {
    this.isMacroChainUser = this.userInfo.userType === MACRO_CHAIN;
    this.isMacroOfficeUser = this.userInfo.userType === MACRO_OFFICE;
    this.isBusinessDirector = this.userInfo.userType === BUSINESS_DIRECTOR;
  };

  private initMacroUsers = (formProperties: string[]) => {
    this.disableFormControls();
    formProperties.forEach((property) => {
      this.operationValidationForm.addControl(property, new FormControl('', Validators.required));
      this.initValueChangesMacroUser(property);
      if (property === FORM_PARAM_MACRO_CHAIN) this.loadMacroChains();
      else if (property === FORM_PARAM_MACRO_OFFICE) this.loadMacroOffices();
    });
  };

  private initValueChangesMacroUser = (property: string) => {
    this.operationValidationForm.controls[property].valueChanges.subscribe((value) => {
      if (value) {
        const request = this.buildRequest();
        this.loadOffices(request);
        this.loadExternalCommercials(request);
        this.loadDocumentSituation();
        if (this.isBusinessDirector)
          this.disableFormControl(
            property === FORM_PARAM_MACRO_CHAIN ? FORM_PARAM_MACRO_OFFICE : FORM_PARAM_MACRO_CHAIN
          );
        this.enableFormControls();
      } else {
        if (this.isBusinessDirector)
          this.enableFormControl(
            property === FORM_PARAM_MACRO_CHAIN ? FORM_PARAM_MACRO_OFFICE : FORM_PARAM_MACRO_CHAIN
          );
        this.disableFormControls();
      }
    });
  };

  private resetCombosExceptMacro = () => {
    this.officeList = [];
    this.externalCommercialList = [];
    this.docSituationList = [];
    Object.keys(this.operationValidationForm.controls).forEach((key) => {
      if (key === 'queryTypes') {
        const form: any = this.operationValidationForm.controls[key];
        Object.keys(form?.controls).forEach((control) => form.get(control)?.setValue(false));
      } else if (key !== FORM_PARAM_MACRO_CHAIN && key !== FORM_PARAM_MACRO_OFFICE) {
        this.operationValidationForm.controls[key].setValue('');
      }
    });
  };

  private disableFormControls = () => {
    if (this.operationValidationForm) {
      Object.keys(this.operationValidationForm.controls).forEach((key) => {
        if (key === 'queryTypes') {
          const form: any = this.operationValidationForm.controls[key];
          Object.keys(form?.controls).forEach((control) => form.get(control)?.setValue(false));
          if (this.operationValidationForm.controls[key].enabled) {
            this.operationValidationForm.controls[key].disable();
          }
        } else if (key !== FORM_PARAM_MACRO_CHAIN && key !== FORM_PARAM_MACRO_OFFICE) {
          this.operationValidationForm.controls[key].setValue('');
          if (this.operationValidationForm.controls[key].enabled) {
            this.operationValidationForm.controls[key].disable();
          }
        }
      });
    }
  };

  private enableFormControls = () => {
    if (this.operationValidationForm) {
      Object.keys(this.operationValidationForm.controls).forEach((key) => {
        if (
          key !== FORM_PARAM_MACRO_CHAIN &&
          key !== FORM_PARAM_MACRO_OFFICE &&
          key !== 'finalDate' &&
          this.operationValidationForm.controls[key].disabled
        ) {
          this.operationValidationForm.controls[key].enable();
        }
      });
    }
  };

  private enableFormControl = (param: string) => {
    if (param) {
      const form = this.operationValidationForm.controls;
      if (form[param]?.disabled) form[param].enable();
    }
  };

  private disableFormControl = (param: string) => {
    if (param) {
      const form = this.operationValidationForm.controls;
      if (form[param]?.enabled) {
        if (form[param].value) form[param].setValue('');
        form[param].disable();
      }
    }
  };

  private updateOfficeByLanguage() {
    //para que se traduzca "todas" o "totes" según idioma en OFICINA
    if (this.searchParams) {
      if (this.searchParams[1].toUpperCase() === 'TODAS' || this.searchParams[1].toUpperCase() === 'TOTES') {
        this.searchParams[1] = this.operationValidationForm.controls.office.value
          ? this.officeList.find((office) => office.id === this.operationValidationForm.controls.office.value)?.value
          : this.translateService.instant('excel.allIdsFem');
      }
    }
  }

  private updateCommercialByLanguage() {
    //para que se traduzca "todos" o "tots" según idioma en COMERCIAL EXTERNO
    if (this.searchParams) {
      if (this.searchParams[2].toUpperCase() === 'TODOS' || this.searchParams[2].toUpperCase() === 'TOTS') {
        this.searchParams[2] = this.operationValidationForm.controls.externalCommercial.value
          ? this.externalCommercialList.find(
              (externalCommercial) =>
                externalCommercial.id === this.operationValidationForm.controls.externalCommercial.value
            )?.value
          : this.translateService.instant('excel.allIds');
      }
    }
  }

  private updateDocumentSituationByLanguage() {
    //para que se traduzca "todos" o "tots" según idioma en SITUACIÓN DOCUMENTO
    if (this.searchParams) {
      if (this.searchParams[3].toUpperCase() === 'TODOS' || this.searchParams[3].toUpperCase() === 'TOTS') {
        this.searchParams[3] = this.operationValidationForm.controls.documentSituation.value
          ? this.docSituationList.find(
              (documentSituation) =>
                documentSituation.id === this.operationValidationForm.controls.documentSituation.value
            )?.value
          : this.translateService.instant('excel.allIds');
      }
    }
  }
}
